<template>
  <div class="theme-custom valign-center flex-center">
    <span>{{ $t('themeCustom.message.test') }}</span>
    <el-color-picker v-model="newColor" @change="onColorChange"></el-color-picker>
    <el-button type="primary">主题颜色</el-button>
  </div>
</template>

<script>
// import theme from '@src/common/lib/theme'
import themeConfig from '@src/common/config/theme'
export default {
  components: {},
  data() {
    return {
      oldColor: themeConfig.THEME_MAP[this.$store.getters.currentTheme].mainColor,
      newColor: themeConfig.ORIGINAL_THEME || '#409EFF'
    }
  },
  computed: {},
  mounted() {},
  methods: {
    onColorChange() {
      // console.log(this.newColor);
      // console.log(this.oldColor);
      // document.documentElement.setAttribute('setColor', this.newColor);
      // let color = document.getElementsByTagName('body')[0].style.getPropertyValue('var(--color-custom)', this.newColor);
      // console.log(color);
      // customStyle = this.newColor;
      // theme.updateThemeByColor({
      //   newTheme: 'custom',
      //   oldTheme: this.$store.getters.currentTheme,
      //   newColor: this.newColor,
      //   oldColor: this.oldColor
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.theme-custom {
  width: 100%;
  height: 100%;
}
</style>